import React from 'react';
import { Text } from './components';

const employee_form_category_personal_profile_key = ['/applicantOnboarding/applicantPersonalProfile'];

const employee_form_category_communication_key = [
  '/applicantOnboarding/applicantPersonalProfile/communication',
];
const employee_form_category_legal_key = [
  '/applicantOnboarding/applicantPersonalProfile/legal',
  '/applicationOnboarding/applicantPersonalProfile/languageCode/',
];

const employee_form_category_tax_profile_key = ['/applicantOnboarding/applicantTaxProfile/'];
const employee_form_category_others = [
  '/applicantOnboarding/applicantPersonalProfile/otherPersonalAddresses',
  '/applicantOnboarding/applicantPersonalProfile/socialInsurancePrograms',
  '/applicantOnboarding/applicantPersonalProfile/tobaccoUserIndicator',
];

const taxSubsectionKeyMap = {
  federalTax: ['/applicantOnboarding/applicantTaxProfile/usFederalTaxInstruction'],
  stateTax: ['/stateIncomeTaxInstructions'],
  localTax: ['/applicantOnboarding/applicantTaxProfile/localTaxInstructions'],
};

const taxSubsectionTitleMap = {
  federalTax: 'Federal Tax',
  stateTax: 'State Tax',
  localTax: 'Local Tax',
};

const section_key_map = {
  personal: employee_form_category_personal_profile_key,
  communication: employee_form_category_communication_key,
  legal: employee_form_category_legal_key,
  employee_tax_profile: employee_form_category_tax_profile_key,
  employee_others: employee_form_category_others,
  ...taxSubsectionKeyMap,
};

const form_section_title_map = {
  personal: 'Personal Information',
  communication: 'Communication',
  legal: 'Legal',
  employee_tax_profile: 'Tax Profile',
  employee_others: 'Others',
};

const renderSectionTitle = (title) => {
  if(!title) return <></>
  return (
    <div>
      <Text fontSize='18px' semibold>{title}</Text>
      <br />
    </div>
  )
}

const taxSubsectionStyle = {
  borderTop: '1px solid #dee1ec',
  marginTop: '16px',
  paddingTop: '16px',
  marginBottom: '12px',
};

const renderTaxSubsectionTitle = (title) => {
  if (!title) return null;
  return (
    <div style={taxSubsectionStyle}>
      <Text fontSize="16px" semibold>{title}</Text>
    </div>
  );
};

export const initializeSectionTitleFlag = () => ({
  personal: 'noShow',
  communication: 'noShow',
  legal: 'noShow',
  employee_tax_profile: 'noShow',
  employee_others: 'noShow',
  federalTax: 'noShow',
  stateTax: 'noShow',
  localTax: 'noShow',
});
  
export const setSectionTitleFlag = (questionKey, sectionTitleFlags) => {
  if (!questionKey) return sectionTitleFlags;
  const sectionTitleFlag = { ...sectionTitleFlags };
  
  Object.keys(sectionTitleFlag).forEach((flag) => {
    if (sectionTitleFlag[flag] === 'show') {
      sectionTitleFlag[flag] = 'shownBefore';
    }
  });
  
  for (const [key, valueArray] of Object.entries(section_key_map)) {
    for (const value of valueArray) {
      if (questionKey.includes(value) && sectionTitleFlag[key] === 'noShow') {
        sectionTitleFlag[key] = 'show';
        break;
      }
    }
  }
  return sectionTitleFlag;
};
  
export const renderSectionTitleBasedOnFlag = (sectionTitleFlag) => {
  let title = '';
  let taxSubsectionTitle = '';

  Object.keys(sectionTitleFlag).forEach((key) => {
    if (sectionTitleFlag[key] !== 'show') return;
    if (taxSubsectionTitleMap[key]) {
      taxSubsectionTitle = taxSubsectionTitleMap[key];
    } else {
      title = form_section_title_map[key] ? form_section_title_map[key] : '';
    }
  });

  return (
    <>
      {renderSectionTitle(title)}
      {renderTaxSubsectionTitle(taxSubsectionTitle)}
    </>
  );
};